module.exports = __webpack_public_path__ + "static/media/noun_bin_1433555-1.e83714ed.svg";